import colocationImg from "public/network-services/colocation-services.jpg";

export const INTRO_CONSTANTS = {
  title: "Managed Colocation",
  description: [
    "OneMind offers a fully managed colocation solution that allows you to host your physical servers and networking equipment in secure, high-performance facilities—without the burden of maintaining your own infrastructure.",
    "Our colocation services deliver enterprise-grade security, redundant power and cooling, and high-speed connectivity, backed by our advanced technology suite and expert remote hands support. It’s a streamlined way to gain full control over your hardware—while we handle the operations.",
  ],
  points: ["Reliable.", "Scalable", "Always connected."],
  image: colocationImg,
  imageHeight: "340px",
};
